import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const Checkout = observer(class Checkout extends React.Component {
  render() {
    const { translation } = this.props;
    // TODO: use the token and sessionSid values in the iframe below when the portal page is built to render the proper
    //  session value

    return (
      <div className='drawer__content'>
        <header className="drawer__header">
          <div className="wrap wrap--large">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>
        <iframe className='iframe--full' src='https://proctor.dev.smarterproctoring.com' />
      </div>
    )
  }
});

export default translate('Checkout')(Checkout);


// WEBPACK FOOTER //
// ./src/app/components/Checkout/Checkout.js